/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconConfucius = createReactComponent("confucius", "IconConfucius", [
  ["path", { d: "M9 19l3 2v-18", key: "svg-0" }],
  ["path", { d: "M4 10l8 -2", key: "svg-1" }],
  ["path", { d: "M4 18l8 -10", key: "svg-2" }],
  ["path", { d: "M20 18l-8 -8l8 -4", key: "svg-3" }]
]);

export { IconConfucius as default };
//# sourceMappingURL=IconConfucius.js.map
